import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DashBoard from "./pages/DashBoard";
import Slider from "./pages/Slider";
import Home from "./pages/Home";
// import "./styles/style.css";
import "./styles/Hom.css";
const App = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route exact path='/dashboard' element={<DashBoard />} />
          <Route exact path='/slider' element={<Slider />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
